import {Platform} from 'react-native';
import WebShare from './platformHelpers/webShare';

let NativeShare: any;

// Only import the native module if not on web
if (Platform.OS !== 'web') {
  // Use dynamic import to avoid issues with webpack
  NativeShare = require('react-native-share').default;
}

type ShareOptions = {
  title?: string;
  message?: string;
  url?: string;
  urls?: string[];
  type?: string;
  subject?: string;
  email?: string;
  recipient?: string;
  social?: string;
  forceDialog?: boolean;
  failOnCancel?: boolean;
  showAppsToView?: boolean;
  [key: string]: any;
};

/**
 * Universal share module that works on both React Native and React Native Web
 */
const Share = {
  /**
   * Open share dialog
   *
   * @param options Share options
   * @returns Promise with the result
   */
  open: async (options: ShareOptions): Promise<{success: boolean}> => {
    try {
      if (Platform.OS === 'web') {
        return await WebShare.open(options);
      } else {
        return await NativeShare.open(options);
      }
    } catch (error) {
      return {success: false};
    }
  },

  /**
   * Check if sharing is available on the device/platform
   *
   * @returns Boolean indicating if sharing is available
   */
  isAvailable: (): boolean => {
    if (Platform.OS === 'web') {
      return WebShare.isAvailable();
    } else {
      return true; // Native platforms generally support sharing
    }
  },

  /**
   * Share to a specific social platform (works only on native)
   * Falls back to regular sharing on web
   *
   * @param options Share options with social target
   * @returns Promise with the result
   */
  shareSingle: async (
    options: ShareOptions & {social: string},
  ): Promise<{success: boolean}> => {
    try {
      if (Platform.OS === 'web') {
        // Web doesn't support direct sharing to specific platforms, use regular share
        return await WebShare.open(options);
      } else {
        return await NativeShare.shareSingle(options);
      }
    } catch (error) {
      return {success: false};
    }
  },
};

export default Share;
